var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9274 3.28027C16.3245 3.28027 16.7415 3.28003 17.1588 3.34668C20.0767 3.62777 22.8362 4.93789 24.9127 7.02344L25.0641 7.10059L25.0739 7.10547L25.0817 7.11328C27.119 9.16427 28.3929 11.899 28.6744 14.8203C28.9558 17.7421 28.2047 20.7042 26.5563 23.1436C25.0106 25.4306 22.7463 27.152 20.15 28.043L19.6266 28.2109C18.4609 28.5459 17.2809 28.7207 16.0612 28.7207H16.0485C14.5241 28.7207 13.0501 28.4532 11.6461 27.9287L11.0485 27.6875C10.8034 27.5844 10.5453 27.5332 10.2877 27.5332H10.0406L4.44788 28.6553L4.26038 28.6543C4.10439 28.6542 3.98703 28.6245 3.87073 28.5664C3.74214 28.5212 3.62837 28.436 3.55627 28.3496C3.44478 28.2364 3.36067 28.0943 3.31799 27.9521L3.31604 27.9512C3.27492 27.8004 3.25899 27.641 3.31506 27.4795L4.46252 21.9863C4.52575 21.6292 4.46193 21.2701 4.31995 20.9473C3.12685 18.2393 2.9536 15.1965 3.77112 12.3818C4.58882 9.56686 6.39784 7.08657 8.83752 5.45117C10.9416 4.03071 13.3944 3.28039 15.9274 3.28027Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesFilled);
export default __webpack_public_path__ + "static/media/messages-filled.651ef726ee288c399d7415ac8c78ddf5.svg";
export { ForwardRef as ReactComponent };